module.exports = __webpack_public_path__ + "static/img/bg4.d39df879.png";